import { QuizData } from '../types/quiz.types';

// In a real application, this would be an API call
// For now, we'll simulate loading the JSON data
export const fetchQuiz = async (id: string): Promise<QuizData> => {
  try {
    // In a production app, this would be a fetch to an API
    const response = await fetch(`/samples/${id}.json`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch quiz with ID: ${id}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching quiz data:', error);
    throw error;
  }
};

// Get a list of available quiz IDs
export const fetchAvailableQuizIds = async (): Promise<string[]> => {
  // This would normally be an API call, but for demo purposes
  // We'll return a hardcoded list of IDs from the samples
  return [
    '2406', '2524', '5024', '3592', '15284', '6453', 
    '4739', '4056', '6462', '3859', '4397', '4584'
  ];
};

// Get a random quiz ID from the available list
export const fetchRandomQuizId = async (): Promise<string> => {
  const ids = await fetchAvailableQuizIds();
  const randomIndex = Math.floor(Math.random() * ids.length);
  return ids[randomIndex];
}; 